import { createUseStyles } from 'react-jss'
import customColors from 'src/config/colorsV2'
import { forPhoneOnly, forTabletPortraitUp } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

const bodyMaxWidth = 544

export default createUseStyles((theme: Theme) => ({
  root: {
    backgroundColor: customColors.background,
  },
  body: {
    [forTabletPortraitUp]: {
      borderTop: 'none',
    },
    display: 'flex',
    width: '100%',
  },
  content: {
    width: '100%',
  },
  stickyContent: {
    position: 'sticky',
    zIndex: 10,
    top: 0,
    backgroundColor: theme.palette.grey[50],
  },
  calendarCont: {
    margin: [0, 'auto'],
    display: 'flex',
    flexDirection: 'column',
    [forTabletPortraitUp]: {
      maxWidth: bodyMaxWidth,
    },
  },
  treatmentContent: {
    [forTabletPortraitUp]: {
      maxWidth: bodyMaxWidth,
    },
  },
  errorContainer: {
    margin: '24px auto 0 auto',
    maxWidth: bodyMaxWidth,
    transition: 'all .5s',
    opacity: 1,
    visibility: 'visible',
    maxHeight: 150,
    [forPhoneOnly]: {
      marginLeft: 16,
      marginRight: 16,
    },
  },
  hideErrorContainer: {
    opacity: 0,
    visibility: 'hidden',
    marginTop: 0,
    maxHeight: 0,
  },
  legalTextContainer: {
    maxWidth: bodyMaxWidth,
    marginBottom: 8,
  },
}))
